import { FocusedSectionAction, SET_POP_DATA } from "../types/FocusedSectionAction";

const initialState = {
  currentlyFocusedSection: "",
  sectionsTouched: new Set(),
  popUpData: null,
};

const focusedSectionReducer = (
  state = initialState,
  action: FocusedSectionAction
) => {
  switch (action.type) {
    case "FOCUS_SECTION": {
      const { data } = action;
      const newState = { ...state };
      newState.currentlyFocusedSection = data;
      const newSectionsTouched = new Set(state.sectionsTouched);
      newSectionsTouched.add(data);
      newState.sectionsTouched = newSectionsTouched;
      return newState;
    }
    case SET_POP_DATA: {
      const { data } = action;
      const newState = { ...state };
      newState.popUpData = data;
      return newState;
    }
    default:
      return state;
  }
};

export default focusedSectionReducer;
